import React, { useContext, useEffect, useRef, useState } from 'react'
import { 
  Container,
  InputFeio,
  InputDiv,
  InputLabel,
  StyledOption,
  StyledSelect,
  DisabledSelect,
  DropdownMenu,
  OptionDiv,
  OptionText,
  StyledSelectCertificate,
  ClientDropdownMenu,
  ClientOptionDiv,
  ClientOptionPlusImg,
  ClientOptionText
} from './style'
import CertificatesContext, { CertificateObject, StructureDataObject } from '../../../../../contexts/CertificatesContext'
import axios from 'axios'
import ParametersContext, { ParamObject } from '../../../../../contexts/ParametersContext'
import plus from '../../../../../assets/certificates/AddCertificate/plus.svg'
import ModalContext from '../../../../../contexts/ModalContext'
import MaterialsDropdown from './MaterialsDropdown'
import HeatNumbersDropdown from './HeatNumbersDropdown'

interface customerData {
  id: number
  cnpj: string
  companyName: string
  stateRegistration: string
  address: string
  phone: string
  email: string
  contactName: string
}

const BasicFields: React.FC = () => {
  const { certificate, structureData, setCertificate, setStructureData, forWhom } = useContext(CertificatesContext)
  const { setModalSection, setModalActive} = useContext(ModalContext)
  const { parameters, setParameters } = useContext(ParametersContext)
  const [ clients, setClients ] = useState<customerData[]>([])
  const [ suppliers, setSuppliers ] = useState<customerData[]>([])
  const [ standardDropdownOpen, setStandardDropdownOpen ] = useState<boolean>(false)
  const [ clientDropdownOpen, setClientDropdownOpen ] = useState<boolean>(false)
  const [ supplierDropdownOpen, setSupplierDropdownOpen ] = useState<boolean>(false)
  const [ materialsDropdownOpen, setMaterialsDropdownOpen ] = useState<boolean>(false)
  const [ searchMaterial, setSearchMaterial ] = useState(certificate.material)
  const [ heatNumbersDropdownOpen, setHeatNumbersDropdownOpen ] = useState<boolean>(false)
  // const [ searchRunNumber, setSearchRunNumber ] = useState(certificate.material)
  const [ blockStandardInput, setBlockStandarInput ] = useState(true)
  const [ certificateTypes, setCertificateTypes ] = useState<{id: number, typeName: string}[]>([])
  const { type } = certificate

  const clientRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_CERTIFICATES_BASE_URL}/certificate-type`)
      .then((response) => {
        if(response.data) setCertificateTypes(response.data)
        return
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])
  
  useEffect(() => {
    const certificateUrl = process.env.REACT_APP_CERTIFICATES_BASE_URL

    axios
    .get(`${certificateUrl}/param`, {
      params: {
        quantity: 9999
      }
    })
    .then((response) => {
      setParameters(response.data)
    })
    .catch((error) => {
      console.log('Ocorreu um erro ao obter os dados do estoque', error)
    })
    .finally(() => {
      console.log("Parameters have been loaded")
    })

    const handleClickOutside = (event: MouseEvent) => {
      if (clientRef.current && !clientRef.current.contains(event.target as Node)) {
        setClientDropdownOpen(false)
        setSupplierDropdownOpen(false)
      }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
          document.removeEventListener('mousedown', handleClickOutside);}
  }, [])

  useEffect(() => {
    const certificateUrl = process.env.REACT_APP_COMPANIES_BASE_URL
    const params = {filters:[1]}

    axios
    .get(`${certificateUrl}/companies`, { params })
    .then((response) => {
      setClients(response.data)
    })
    .catch((error) => {
      console.log('Ocorreu um erro ao obter os dados do cliente', error)
    })
    .finally(() => {
      console.log("Clients have been loaded")
    })
  }, [clientDropdownOpen])

  useEffect(() => {
    const certificateUrl = process.env.REACT_APP_COMPANIES_BASE_URL
    const params = {filters:[2]}

    axios
    .get(`${certificateUrl}/companies`, { params })
    .then((response) => {
      setSuppliers(response.data)
    })
    .catch((error) => {
      console.log('Ocorreu um erro ao obter os dados dos fornecedores', error)
    })
    .finally(() => {
      console.log("Suppliers have been loaded")
    })
  }, [supplierDropdownOpen])

  useEffect(() => {
    if(forWhom !== 'customer'){
      return setCertificate((prevCertificate) => ({
        ...prevCertificate,
        customerCompany:{id:1, companyName:'Dustre'}
      }))
    }
    return setCertificate((prevCertificate) => ({
      ...prevCertificate,
      supplierCompany:{id:1, companyName:'Dustre'}
    }))
  }, [])

  const fieldHeaders = ['Matéria prima', 'Perfil do produto', 'Corrida/RE']
  const fieldNames: (keyof CertificateObject)[] = ['material', 'profile', 'heatNumber']

  //função pra poder indexar o objeto certificates por uma string sem dar problema por conta dos tipos diferentes em CertificateObject
  const getStringValue = (field: keyof CertificateObject, certificate: CertificateObject): string | undefined => {
    const value = certificate[field];
    return typeof value === 'string' ? value : undefined;
  };

  const setParameterToStructure = (index: number) => {
    if(index < 0){
      setStructureData([])
      return
    }
    const newStructureData: StructureDataObject[] = parameters[index].structuresArray.map((structure) => {
      const { id, name, fileImport, hasTable, tableRows, tableColumns, hasMinMax, minTable, maxTable, format } = structure
      const arrayOfArrays: string[][] = Array.from({ length: tableRows.length }, () => Array(tableColumns.length).fill(''));
      if (hasMinMax){
        return {
          id: id !== undefined ? id : undefined,
          name: name,
          fileImport: fileImport,
          hasTable: hasTable,
          tableData: arrayOfArrays,
          tableRows: tableRows,
          tableColumns: tableColumns,
          minTable: minTable,
          maxTable: maxTable,
          format: format,
          structureFile: null,
        }
      }
      return {
        id: id !== undefined ? id : undefined,
        name: name,
        fileImport: fileImport,
        hasTable: hasTable,
        tableData: arrayOfArrays,
        tableRows: tableRows,
        tableColumns: tableColumns,
        minTable: [],
        maxTable: [],
        format: format,
        structureFile: null,
      }
    })
    setCertificate((oldCertificate:any) => ({
      ...oldCertificate,
      type: parameters[index].type
    }))
    setStructureData(newStructureData)
  }

  useEffect(() => {
    if(type.id == 0){
      setBlockStandarInput(true)
      return
    }
    setBlockStandarInput(false)
  }, [type])

  /**
   * Handles the change of a input field in the certificate form and updates
   * the certificate state accordingly.
   * @param {React.ChangeEvent<HTMLInputElement>} e The event containing the
   * input field's name and new value.
   */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target
    setCertificate((prevCertificate) => ({
      ...prevCertificate,
      [name]: value
    }))
  }

  const handleClientChange = (company:{id:number, companyName:string}, isItCustomer:boolean) => {
    if(isItCustomer){
      setCertificate((prevCertificate) => ({
        ...prevCertificate,
        customerCompany: company
      }))
      return
    }
    setCertificate((prevCertificate) => ({
      ...prevCertificate,
      supplierCompany: company
    }))
    setClientDropdownOpen(false)
  }

  const handleTypeChange = (value: string|number) => {
    const objectType = certificateTypes.find((type) => type.id == value)
    if (objectType) {
      setCertificate((prev) => ({
        ...prev,
        type: objectType,
      }))
    }    
    setStructureData([])
  }

  const handleDropdownClick = (value: string) => {
    setCertificate((prevCertificate) => ({
      ...prevCertificate,
      standard: value
    }))
    const paramIndex = parameters.findIndex(parameter => parameter.name == value)
    setParameterToStructure(paramIndex)
    setStandardDropdownOpen(false)
  }

  const handleDropdownInput = (value: string) => {
    setCertificate((prevCertificate) => ({
      ...prevCertificate,
      standard: value
    }))
    setStandardDropdownOpen(true)
    // -1 se não existir
    const paramIndex = parameters.findIndex(parameter => parameter.name == value)
    setParameterToStructure(paramIndex)
  }

  const handleClientModal = () => {
    setModalSection('addCustomer')
    setModalActive(true)
  }

  let filteredParameters = parameters
  if (certificate.standard !== "" && certificate.standard !== null){
    filteredParameters = filteredParameters.filter(parameter => parameter.name.toLowerCase().includes(certificate.standard.toLowerCase()))
  }
  if (certificate.type.id !== 0){
    filteredParameters = filteredParameters.filter(paramater => paramater.type.id === certificate.type.id)
  }

  return (
      <Container>
        <InputDiv>
          <InputLabel htmlFor='issuer'>Fornecedor</InputLabel>
          {forWhom === 'customer' ? 
            <DisabledSelect disabled>
              <StyledOption defaultValue=''>{certificate.supplierCompany.companyName}</StyledOption>
            </DisabledSelect>
            :
            <StyledSelectCertificate onClick={() => setSupplierDropdownOpen(!supplierDropdownOpen)}>
              {!certificate.supplierCompany.id ? 'Selecione' : certificate.supplierCompany.companyName} 
              {supplierDropdownOpen ?
                <ClientDropdownMenu ref={clientRef}>
                  <ClientOptionDiv className='addDiv' onClick={() => handleClientModal()}>
                    <ClientOptionPlusImg src={plus} alt='Plus icon' />
                    <ClientOptionText className='addText'>Adicionar Fornecedor</ClientOptionText>
                  </ClientOptionDiv>
                  {suppliers.map((supplier) => (
                    <ClientOptionDiv key={supplier.companyName} onClick={() => handleClientChange({id:supplier.id, companyName:supplier.companyName}, false)}>
                      <ClientOptionText>{supplier.companyName}</ClientOptionText>
                    </ClientOptionDiv>
                  ))}
                </ClientDropdownMenu>
              : null}
            </StyledSelectCertificate>
          }
        </InputDiv>
        <InputDiv>
          <InputLabel htmlFor='customer'>Cliente</InputLabel>
          {forWhom !== 'customer' ? 
            <DisabledSelect disabled>
              <StyledOption defaultValue=''>{certificate.customerCompany.companyName}</StyledOption>
            </DisabledSelect>
          :
            <StyledSelectCertificate onClick={() => setClientDropdownOpen(!clientDropdownOpen)}>
              {!certificate.customerCompany.id ? 'Selecione' : certificate.customerCompany.companyName}
              {clientDropdownOpen ?
                <ClientDropdownMenu ref={clientRef}>
                  <ClientOptionDiv className='addDiv' onClick={() => handleClientModal()}>
                    <ClientOptionPlusImg src={plus} alt='Plus icon' />
                    <ClientOptionText className='addText'>Adicionar Cliente</ClientOptionText>
                  </ClientOptionDiv>
                  {clients.map((client) => (
                    <ClientOptionDiv key={client.companyName} onClick={() => handleClientChange({id:client.id, companyName:client.companyName}, true)}>
                      <ClientOptionText>{client.companyName}</ClientOptionText>
                    </ClientOptionDiv>
                  ))}
                </ClientDropdownMenu>
              : null}
            </StyledSelectCertificate>
          }
        </InputDiv>
        <InputDiv>
          <InputLabel htmlFor='type'>Tipo de certificado</InputLabel>
          <StyledSelect
            name='type'
            value={certificate.type.id}
            onChange={(e:any) => handleTypeChange(e.target.value)}
          >
            <StyledOption value={0}>Selecione</StyledOption>
            {certificateTypes.map((item) => (
              <StyledOption key={item.id} value={item.id}>{item.typeName}</StyledOption>
            ))}
          </StyledSelect>
        </InputDiv>
        <InputDiv>
            {standardDropdownOpen && filteredParameters.length !== 0 &&
              <DropdownMenu onMouseDown={(e) => e.preventDefault()}>
                  {filteredParameters.map((parameter, index) => 
                    <OptionDiv key={index} onClick={() => handleDropdownClick(parameter.name)}>
                      <OptionText>{parameter.name}</OptionText>
                    </OptionDiv>
                  )}
              </DropdownMenu>
            }
            <InputLabel htmlFor='standard'>Norma</InputLabel>
            <InputFeio
              placeholder={!blockStandardInput ? 'Digite aqui' : 'Selecione o tipo'}
              className={blockStandardInput ? 'disabled' : ''}
              autoComplete="off"
              disabled={blockStandardInput}
              value={certificate.standard}
              name='standard'
              onChange={(e:any) => handleDropdownInput(e.target.value)}
              onFocus={() => setStandardDropdownOpen(true)}
              onBlur={() => setStandardDropdownOpen(false)}
              onClick={()  => setStandardDropdownOpen(true)}
            />
        </InputDiv>
        {fieldNames.map((field, index) => (
          <>
            {field === 'material' && forWhom === 'customer' ? (
              <InputDiv key={field}>
                <InputLabel htmlFor={field}>{fieldHeaders[index]}</InputLabel>
                <InputFeio
                  placeholder='Digite aqui'
                  // value={getStringValue(field, certificate)}
                  onFocus = {() => setMaterialsDropdownOpen(!materialsDropdownOpen)}
                  value={certificate.material === '' || materialsDropdownOpen === true ? searchMaterial : certificate.material}
                  name={field}
                  onChange={(e:any) => setSearchMaterial(e.target.value)}
                  autoComplete="off"
                />
                {materialsDropdownOpen ? <MaterialsDropdown search={searchMaterial} open={setMaterialsDropdownOpen} setNewSearch={setSearchMaterial} /> : null}
              </InputDiv>
            ):
            null
            // (
            //   <InputDiv key={field}>
            //     <InputLabel htmlFor={field}>{fieldHeaders[index]}</InputLabel>
            //     <Input
            //       placeholder='Digite aqui'
            //       value={getStringValue(field, certificate)}
            //       name={field}
            //       onChange={(e:any) => handleChange(e)}
            //     />
            //   </InputDiv>
            // )
            }
          </>
        ))}
        {forWhom !== 'customer' &&
          <InputDiv>
            <InputLabel>Número de corrida</InputLabel>
            <StyledSelectCertificate ref={clientRef} onClick={() => {setHeatNumbersDropdownOpen(!heatNumbersDropdownOpen)}}>
              {certificate.heatNumber.heatNumber || certificate.heatNumber.heatNumber || 'Selecione'}
            </StyledSelectCertificate>
            {heatNumbersDropdownOpen ? <HeatNumbersDropdown /*search={searchMaterial}*/ open={setHeatNumbersDropdownOpen} /*setNewSearch={setSearchMaterial}*/ /> : null}
          </InputDiv>
        }
      </Container>
  )
}
export default BasicFields
